module.exports = __webpack_public_path__ + "img/todr.d18ad365.png";